import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { ContentNotificationTypesGrid } from '@/modules/configurationModule/detail/notifications/components/notification-types-grid/notification-types-grid.models'
import {
    NotificationTemplateCreateRequest,
    NotificationTemplateUpdateRequest
} from '@/modules/configurationModule/detail/notifications/models/notification-templates'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ContentCustomNotificationTextTemplateGrid } from '@/modules/configurationModule/detail/notifications/components/notification-templates-grid/notifications-templates-grid.model'

class NotificationTemplatesService {
    async paginator(filterModel: any, params: any, laboratoryId: number): Promise<IResponseAgGrid<ContentCustomNotificationTextTemplateGrid>> {
        const response = await axios.put<IResponseAgGrid<ContentCustomNotificationTextTemplateGrid>>(`/configuration/laboratories/${laboratoryId}/customNotificationTextTemplates`, filterModel, { params })
        return response.data
    }
    async getTemplateNotificationById(notificationConfigurationId: number, laboratoryId: number): Promise<ContentNotificationTypesGrid> {
        const response = await axios.get(`/configuration/laboratories/${laboratoryId}/customNotificationTextTemplates/${notificationConfigurationId}`)
        return response.data
    }
    async patchTemplateNotificationBatch(request: NotificationTemplateUpdateRequest[], laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch(`/configuration/laboratories/${laboratoryId}/customNotificationTextTemplates/batch`, request)
        return response.data
    }
    async createTemplateNotification(request: NotificationTemplateCreateRequest, laboratoryId: number): Promise<ContentNotificationTypesGrid> {
        const response = await axios.post(`/configuration/laboratories/${laboratoryId}/customNotificationTextTemplates`, request)
        return response.data
    }
    async deleteTemplateNotificationBatch(request: EntityIdentifiersRequest, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete(`/configuration/laboratories/${laboratoryId}/customNotificationTextTemplates/batch`, { data: request })
        return response.data
    }
}
export const notificationTemplatesService = new NotificationTemplatesService()
